module.exports = __webpack_public_path__ + "static/cashew_nuts_tieu_xanh_1-25c1a8edb835f5632c4aa7bc914b91fd.jpg";